<template>
  <div class="image-comp" v-viewer>
    <img
      :class="{ pointer: eject }"
      :src="fullSrc"
      :width="width"
      :height="height"
      @click="newWindow"
    />
  </div>
</template>
<script>
export default {
  props: ['src', 'width', 'height', 'eject'],
  computed: {
    fullSrc() {
      return `${this.src}`
    },
  },
  methods: {
    newWindow() {
      // if (this.eject) window.open(this.fullSrc)
    },
  },
}
</script>
<style lang="less" scoped>
  .image-comp{
    img{
      cursor: pointer;
    }
  }
</style>
